import type {
  FilterTypeKeysWithJaneGold,
  ProductSearchFiltersViewModel,
} from '@jane/bloom/viewModels/productSearchFilters';

const chipOrder: FilterTypeKeysWithJaneGold[] = [
  'jane-gold',
  'categories',
  'brands',
  'lineages',
  'specials',
  'terpenes',
];

interface FilterAndSortChipListArgs {
  availableFilters?: ProductSearchFiltersViewModel;
  chipOrder: FilterTypeKeysWithJaneGold[];
  filters: FilterTypeKeysWithJaneGold[];
  janeGold?: boolean;
}

const filterAndSortChipList = ({
  availableFilters,
  chipOrder,
  filters,
  janeGold,
}: FilterAndSortChipListArgs) => {
  return filters
    .filter((filter) => {
      let hasAvailableFilters = false;
      if (filter === 'potencies') {
        if (
          Number(availableFilters?.cbdPotencies.length) > 0 ||
          Number(availableFilters?.thcPotencies.length) > 0
        ) {
          hasAvailableFilters = true;
        }
      } else {
        if (
          filter !== 'jane-gold' &&
          Number(availableFilters?.[filter].length) > 0
        ) {
          hasAvailableFilters = true;
        } else if (filter === 'jane-gold' && janeGold) {
          hasAvailableFilters = true;
        }
      }
      return hasAvailableFilters && chipOrder.includes(filter);
    })
    .sort((a, b) => {
      return chipOrder.indexOf(a) - chipOrder.indexOf(b);
    })
    .slice(0, 5);
};

export const getFilterChips = ({
  availableFilters,
  filters,
  janeGold,
}: {
  availableFilters?: ProductSearchFiltersViewModel;
  filters: FilterTypeKeysWithJaneGold[];
  janeGold?: boolean;
}) => {
  return filterAndSortChipList({
    availableFilters,
    chipOrder,
    filters,
    janeGold,
  });
};
